// extracted by mini-css-extract-plugin
module.exports = {"dialog-upload":"dialog-upload-2f020a2f653303541a21e62472211b27"};